import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-integration-foyr-form',
  templateUrl: './integration-foyr-form.component.html',
  styleUrls: ['./integration-foyr-form.component.scss']
})
export class IntegrationFoyrFormComponent {
  @Input() formGroup!: FormGroup;
}
